module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ack",
      "epub:type": "acknowledgments",
      "role": "doc-acknowledgments"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "BM-Head-bmh",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "189",
      "id": "pg_189",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Acknowledgments")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "BM-Text-No-Indent-bmtx1"
  }, [_vm._v("This book was made possible by my husband, Joel; my family; my agent, Julia Kenny; and Caroline Zancan, Kerry Cullen, and everyone at Holt.")]), _vm._v(" "), _c('p', {
    staticClass: "BM-Text-bmtx"
  }, [_vm._v("Deepest gratitude to the friends, mentors, and editors who helped these stories along: Edward Carey, Elizabeth McCracken, Naomi Shihab Nye, Lara Prescott, Rachel Heng, Maria Reva, Sindya Bhanoo, Kate Kelly, Olga Vilkotskaya, Nouri Zarrough, Marla Akin, Jim Magnuson, Terry Kennedy, Belle Boggs, Wilton Barnhardt, Margaret Bauer, Liza Weiland, Anna Lena Phillips Bell, Beth Staples, Brandon Taylor, Robert Gipe, David Joy, Silas House, Jason Howard, Charles Dodd White, Denton Loving, Elizabeth Glass, Mark Powell, Wesley Browne, Sarah Ivens Moffett, Mimi Fenton, Darnell Arnoult, Steve Scafidi, Tracie Matysik, Wiley Cash, Robyn Shaw Cnockaert, and the TSWT writers group. Special thanks to everyone in my beloved Michener cohort and my Hindman family.")]), _vm._v(" "), _c('p', {
    staticClass: "BM-Text-bmtx"
  }, [_vm._v("The following institutions/entities generously supported my work: the Appalachian Writers Workshop at Hindman, the Michener Center for Writers, Hedgebrook, the Vermont Studio Center, the Mountain Heritage Literary Festival, the University of "), _c('span', {
    attrs: {
      "aria-label": "190",
      "id": "pg_190",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Texas at Austin, Wildacres Retreat, A-BTech Community College, Western North Carolina Arts Council, North Carolina Writers Network, North Carolina State University, the Adirondack Center for Writing, and the Stadler Center for Poetry and Literary Arts.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-466fc50a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 72
// module chunks = 0